import axios from "axios";

// Original OpenRouter configuration (commented out)
// const openRouterAxios = axios.create({
//   baseURL: "https://openrouter.ai/api/v1",
//   headers: {
//     "Authorization": `Bearer ${process.env.REACT_APP_OPENROUTER_API_KEY}`,
//     "Content-Type": "application/json",
//     "HTTP-Referer": "https://web.workbrook.com",
//     "X-Title": "workbrook",
//   },
// });

// OpenAI configuration
// const openAIAxios = axios.create({
//   baseURL: "https://api.openai.com/v1",
//   timeout: 60000, // 60 second timeout to prevent indefinite loading
//   headers: {
//     Authorization: `Bearer ${process.env.REACT_APP_OPENAI_API_KEY}`,
//     "Content-Type": "application/json",
//   },
// });

// export const openRouter = {
//   chat: async (messages) => {
//     try {
//       console.log("Sending request to OpenAI API...");
//       // Using GPT-4o for much faster performance and lower latency
//       const response = await openAIAxios.post("/chat/completions", {
//         model: "gpt-4o",
//         messages,
//         temperature: 0,
//       });

//       console.log("OpenAI API response received successfully.");
//       return response.data.choices[0].message.content;
//     } catch (error) {
//       if (error.code === "ECONNABORTED") {
//         console.error("OpenAI API Timeout: The request took too long.");
//         throw new Error(
//           "OpenAI API request timed out. The resume might be too large or the service is slow.",
//         );
//       }

//       const errorMessage =
//         error.response?.data?.error?.message || error.message;
//       console.error(
//         "OpenAI API Error details:",
//         error.response?.data || error.message,
//       );

//       if (errorMessage.includes("CORS") || error.message === "Network Error") {
//         throw new Error(
//           "CORS Error: OpenAI does not allow direct browser calls. Please check if your environment requires a proxy or use OpenRouter.",
//         );
//       }

//       throw new Error(`OpenAI API failed: ${errorMessage}`);
//     }
//   },
// };

// Usage example:
// openRouter.chat([
//   {
//     role: "user",
//     content: "Hello, how are you?",
//   },
// ]);


// Your own API configuration
const apiAxios = axios.create({
  baseURL: `${process.env.REACT_APP_BASE_URL}`, // Adjust based on your environment
  timeout: 65000,
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json",
  },
});

export const openRouter = {
  chat: async (messages) => {
    try {
      console.log("Sending request to AI Proxy...");
      const response = await apiAxios.post("/ai/chat", {
        messages,
        model: "gpt-4o",
        temperature: 0,
      });

      console.log("Response received from proxy.");
      return response.data.data;
    } catch (error) {
      if (error.response) {
        const status = error.response.status;
        const message =
          error.response.data?.message ||
          error.response.data?.error ||
          error.response.statusText ||
          "Unknown server error";

        console.error("AI Proxy Error:", {
          status,
          message,
          data: error.response.data,
        });

        throw new Error(`AI proxy returned ${status}: ${message}`);
      }

      const errorMessage =
        error.code === "ECONNABORTED"
          ? "AI proxy request timed out."
          : error.message === "Network Error"
          ? "Unable to read AI proxy response. The API may be returning an error without CORS headers."
          : error.message;

      console.error("AI Proxy Error:", errorMessage);
      throw new Error(`AI Request failed: ${errorMessage}`);
    }
  },
};